<ng-container *ngIf="!pageReady">
	<div class="d-flex justify-content-center align-items-center vh-100"><span class="jmWidgetLoadingIcon40"></span></div>
</ng-container>

<ng-container *ngIf="pageReady">
	<app-global-account></app-global-account>
	<!--<div id="divMyProgressBlocker" style="position:fixed;width: 100%; height: 100%; display: flex; flex-direction: column;">-->
	<div style="position:absolute; right:0; top:0; padding:20px; z-index: 10;">
		<div style="display: flex; align-items: center; justify-content: center;">
			<div (click)="doNext('cancel')" role="button" class="jmCloseBtn"></div>
		</div>
	</div>

	<!---->
	<div style="display: flex; width: 100%; overflow: hidden;" [style.flex-direction]="showMinimize?'column':'row'" class="gTextBody" [style.height]="windowInnerHeight">
		<!--image area desktop-->
		<div *ngIf="!showMinimize" style="width: 50%; height: 100%; display: flex; flex-direction: column; justify-content: center;" class="gBackgroundImageColor">
			<!--login-->
			<div *ngIf="!showMinimize" class="imgContainerDesktop">
				<img class="imgDesktop" src="assets/images/what_do_you_want_to_explore.png">
			</div>
		</div>
		<!--image area mobile-->
		<div *ngIf="showMinimize" class="gBackgroundImageColor imgContainerMobile">
			<!--login-->
			<div class="imgMobile" style="background-image: url('assets/images/what_do_you_want_to_explore.png');"></div>
		</div>
		<!--form area-->
		<div [ngClass]="(showMinimize)?'formContainerMobile':'formContainerDesktop'" style="background-color: white; display: flex; flex-direction: column; justify-content: center; overflow-y: hidden; overflow-x: hidden; position: relative;">

			<div class="row">
				<div [ngClass]="(showMinimize)?'col-10 offset-1':'col-8 offset-2'">
					<!--form content-->
					<div class="componentFormContainer">
						<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
						<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">What do you want to <span class="gColorAccentPrimary">Explore</span>?</h1>
						<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">
							<button type="button" (click)="doNext('interest')" class="btn btn-lg" [ngClass]="interestComplete?'btn-outline-primary':'btn-primary'" style="width: 100%;">Discover My Interests</button>
						</div>
						<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">
							<button type="button" (click)="doNext('skill')" class="btn btn-lg" [ngClass]="interestComplete?'btn-outline-primary':'btn-primary'" style="width: 100%;">Learn My Skills</button>
						</div>
						<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">
							<button type="button" (click)="doNext('explore')" class="btn btn-lg" [ngClass]="interestComplete?'btn-outline-primary':'btn-primary'" style="width: 100%;">Explore Careers</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--	</div>-->
</ng-container>
